import { createFileRoute } from '@tanstack/react-router'
import ContactEditions from 'Contact/components/Contact/Sections/ContactEditions'

export const Route = createFileRoute('/contact/$contactId/productions')({
    component: ContactEditions,
})
